import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface Props {
  to: string;
  label: any;
  openInNewWindow?: boolean;
  exact?: boolean;
  activeRoutes?: string[];
  inactiveRoutes?: string[];
}

export const isActiveLink = (
  pathName: string,
  to: string,
  activeRoutes?: string[],
  inactiveRoutes?: string[],
  exact?: boolean
) => {
  if (inactiveRoutes) {
    if (inactiveRoutes.find((route) => new RegExp(route).test(pathName))) {
      return false;
    }
  }

  if (activeRoutes) {
    return activeRoutes.find((route) => new RegExp(route).test(pathName));
  }

  if (exact) {
    return pathName === to;
  }
  return to === '/' || pathName === to || pathName.startsWith(`${to}/`);
};

const NavLink: React.FC<Props> = (props): React.ReactElement => {
  const location = useLocation();

  return (
    <Link
      to={props.to}
      className={`NavLink ${
        isActiveLink(
          location.pathname,
          props.to,
          props.activeRoutes,
          props.inactiveRoutes,
          props.exact
        )
          ? 'active'
          : ''
      }`}
      target={props.openInNewWindow ? '_blank' : undefined}
      aria-current={
        isActiveLink(
          location.pathname,
          props.to,
          props.activeRoutes,
          props.inactiveRoutes,
          props.exact
        )
          ? 'page'
          : undefined
      }
    >
      {props.label}
    </Link>
  );
};

export default NavLink;
